import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Search, User, Info, LogOut, BarChart, Calculator } from 'lucide-react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || '',
  import.meta.env.VITE_SUPABASE_ANON_KEY || ''
);

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <nav className="bg-card/50 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <button 
            onClick={() => navigate('/')}
            className="text-xl font-bold text-primary hover:text-primary/90"
          >
            Location Scout
          </button>
          
          <div className="flex items-center space-x-4">
            <button 
              onClick={() => navigate('/search')}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="Search"
            >
              <Search size={20} />
            </button>
            <button 
              onClick={() => navigate('/analytics')}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="Analytics"
            >
              <BarChart size={20} />
            </button>
            <button 
              onClick={() => navigate('/financial-tools')}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="Financial Tools"
            >
              <Calculator size={20} />
            </button>
            <button 
              onClick={() => navigate('/profile')}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="Profile"
            >
              <User size={20} />
            </button>
            <button 
              onClick={() => navigate('/about')}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="About"
            >
              <Info size={20} />
            </button>
            <button 
              onClick={handleLogout}
              className="p-2 text-muted-foreground hover:text-foreground"
              aria-label="Logout"
            >
              <LogOut size={20} />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;